import React, { lazy } from 'react';
import { Gift, CheckCircle } from 'lucide-react';
import { PriceDisplay } from '../ui/PriceDisplay';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Recetario de Snacks y Premios Saludables — "El Libro de las Delicias"',
    desc: '50 recetas de snacks caseros que tu mascota va a enloquecerle. Perfectos para el entrenamiento, para premios diarios, o simplemente para consentirlos con algo sano.',
    sub: 'Nada de galletitas con colorantes. Estas recetas son 100% naturales, rápidas y económicas.',
    valueType: 'b1' as const,
    image: 'https://cdn.magicpatterns.com/uploads/8NncRqdjXAjgrovoecjGaC/20260318_2303_Libro_de_Delicias_simple_compose_01km1xaqs0fyrbzkcm66z2ebx8_(1).webp'
  }, {
    num: '2',
    title: 'Guía de Primeros Auxilios Nutricionales — "¿Qué Hago Si...?"',
    desc: '¿Tu mascota comió algo que no debía? ¿Tiene diarrea de repente? ¿No come hace dos días? Esta guía te da los pasos exactos a seguir en cada emergencia nutricional común antes de llegar al veterinario.',
    sub: 'La tenés en el celular, disponible 24/7. Cuando la necesitás, la tenés.',
    valueType: 'b2' as const,
    image: 'https://cdn.magicpatterns.com/uploads/aQJsqTwQL4sh7rvhWpLE5u/20260318_1308_Image_Generation_simple_compose_01km0v8b0rex4at2e9fk2zp784_(1)_(1).webp'
  }, {
    num: '3',
    title: 'Acceso al Grupo Privado "Familia Alimenta Con Amor" — Comunidad de Por Vida',
    desc: 'Más de 2.000 dueños apasionados compartiendo fotos de sus mascotas transformadas, resolviendo dudas, intercambiando recetas y apoyándose mutuamente.',
    sub: 'Cuando tenés una duda a las 11 de la noche, ahí siempre hay alguien que ya pasó por lo mismo.',
    valueType: 'b3' as const,
    isYearly: true,
    image: 'https://cdn.magicpatterns.com/uploads/8qZ3y39LpvWnRFJU1LzGs3/20260318_2308_Image_Generation_simple_compose_01km1xm7amekt8zj474rdw6a1h_(1).webp'
  }, {
    num: '4',
    title: 'Los 10 Errores que Pueden Estar Dañando la Salud de tu Mascota',
    desc: 'Guía rápida tipo "alerta" que revela los errores más comunes que cometen los dueños sin saberlo — y que pueden estar afectando la salud de tu mascota en este momento.',
    sub: 'Activa miedo + urgencia. Descubrí qué estás haciendo mal antes de que sea demasiado tarde.',
    valueType: 'b4' as const,
    image: 'https://cdn.magicpatterns.com/uploads/oV7mu4c4ipvU6ZXBfpCLfY/20260326_0751_Image_Generation_simple_compose_01kmmwaqsze2aafz2h914aftts_(1).webp'
  }, {
    num: '5',
    title: 'Lista Inteligente de Compras para Alimentación Natural',
    desc: 'Checklist listo para ir al súper. Sabés exactamente qué comprar, ahorrás tiempo y evitás errores.',
    sub: 'Hace todo más fácil → menos esfuerzo = más compras. Todo organizado para que no te olvides nada.',
    valueType: 'b5' as const,
    image: 'https://cdn.magicpatterns.com/uploads/pdGksv3Cu3oFjkDeoBYPQ8/20260326_0749_Image_Generation_simple_compose_01kmmw607jfghbkfjr4xvadrgr_(1).webp'
  }];
  return <section className="py-16 px-4 bg-[#fdfbf7] text-gray-900 relative overflow-hidden" data-id="element-18">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#8ba888 2px, transparent 2px)',
      backgroundSize: '40px 40px'
    }} data-id="element-19"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-20">
        <div className="text-center mb-12" data-id="element-21">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#8ba888] font-serif leading-tight drop-shadow-sm" data-id="element-22">
            Si Pedís Hoy, Estos 5 Bonos Exclusivos Son Tuyos Gratis:
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-23">
          {bonuses.map((bono, idx) => <div key={idx} className="flex flex-col items-center" data-id="element-24">
              {/* Top Label */}
              <div className="text-[#b08d5b] font-black text-sm md:text-base mb-2 flex items-center gap-1 uppercase tracking-wide" data-id="element-25">
                <span className="text-[#df4b5b] text-xs" data-id="element-26">🎁</span> REGALO{' '}
                {bono.num} <span className="text-[#df4b5b] text-xs" data-id="element-27">🎁</span>
              </div>

              {/* Green Frame */}
              <div className="bg-[#8ba888] p-2 md:p-3 rounded-[1.5rem] w-full shadow-lg transform transition-transform hover:-translate-y-1" data-id="element-28">
                {/* Inner White Card */}
                <div className="bg-white rounded-[1.25rem] p-3 md:p-4 flex flex-col items-center text-center h-full min-h-[280px] shadow-inner" data-id="element-29">
                  {bono.image ? <img src={bono.image} alt={bono.title} className="w-full max-w-[140px] object-contain mb-3 drop-shadow-md" loading="lazy" decoding="async" width={140} height={180} data-id="element-30" /> : <div className="w-full max-w-[140px] h-[120px] bg-gray-50 rounded-xl mb-3 flex items-center justify-center border-2 border-dashed border-gray-200" data-id="element-31">
                      <span className="text-gray-400 font-medium text-xs" data-id="element-32">
                        Guía Práctica
                      </span>
                    </div>}

                  <h3 className="text-xs md:text-sm font-black text-gray-800 mb-2 leading-tight font-serif line-clamp-3" data-id="element-33">
                    {bono.title}
                  </h3>

                  <p className="text-[10px] md:text-xs text-gray-600 mb-2 flex-grow font-medium line-clamp-3" data-id="element-34">
                    {bono.desc}
                  </p>

                  <div className="bg-green-50 px-2 py-1 rounded-lg w-full border border-green-100" data-id="element-35">
                    <p className="text-[9px] md:text-[10px] font-bold text-[#8ba888] line-clamp-2" data-id="element-36">
                      {bono.sub}
                    </p>
                  </div>
                </div>
              </div>

              {/* Price & Button */}
              <div className="mt-3 flex flex-col items-center w-full" data-id="element-37">
                <div className="text-gray-600 font-bold text-xs md:text-sm mb-1 flex items-center gap-1" data-id="element-38">
                  VALOR:{' '}
                  <span className="relative text-gray-500" data-id="element-39">
                    <PriceDisplay type={bono.valueType} showCurrencyCode data-id="element-40" />
                    <div className="absolute top-1/2 left-0 w-full h-[2px] bg-[#df4b5b] -translate-y-1/2 opacity-80" data-id="element-41"></div>
                  </span>
                </div>

                <div className="bg-[#df4b5b] text-white font-black text-sm md:text-base px-4 py-2 rounded-full w-[90%] text-center shadow-[0_4px_15px_rgba(223,75,91,0.4)] uppercase tracking-wider border-b-4 border-black/10" data-id="element-42">
                  HOY GRATIS
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}